import OProjectNavAdmin from './o-project-nav-admin.vue'

export default OProjectNavAdmin
